import script from "./MockExamPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./MockExamPage.vue?vue&type=script&setup=true&lang=ts"

import "./MockExamPage.vue?vue&type=style&index=0&id=75b97377&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75b97377"]])

export default __exports__